//todo change labels

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`,
        },
    ];
};

const step_schema_mini_bus = [
    //Vehicle
    //-----------
    {
        key: 'vrm'
    },
    {
        key: 'make',
        skip_question: true,
    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        skip_question: true,
    },
    {
        key: 'seats'
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true
    },
    {
        key: 'address2',
        skip_question: true
    },
    {
        key: 'address3',
        skip_question: true
    },
    {
        key: 'address4',
        skip_question: true
    },
    {
        key: 'city',
        skip_question: true
    },
    {
        key: 'licence_type'
    },
    {
        key: 'licence_date'
    },
    {
        key: 'occupation_0_type'
    },
    {
        key: 'occupation_0_more',
        children: secondOccupation(),
        required_children: value => value === true
    },
    //policy
    {
        key: 'cover_date',
    },
    {
        key: 'cover_duration'
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_mini_bus;
